import 'jquery-cookie';

export default function getTreatment(name) {
  if (!SS.serverBootstrap.flags) {
    return false;
  }
  return SS.serverBootstrap.flags[name];
}

export function getAllFlagTreatments() {
  if (!SS.serverBootstrap.flags) {
    return {};
  }

  return SS.serverBootstrap.flags;
}

// gr_mui_auth
export function shouldMUIAuth() {
  return getTreatment('gr_mui_auth') == 'on';
}

// pl_a0_web
export function shouldShowAuth0() {
  return getTreatment('pl_a0_web') === 'on';
}

export function isMultiLanguageSubtitlesEnabled() {
  return getTreatment('lx_ml_sbs') === 'on';
}

export function deferredVideoPlayerTestIsActive() {
  return getTreatment('lx_growth_vpdl') === 'on';
}

export function shouldRenderClassCreatorUpdates() {
  return getTreatment('lx_cc_sqs') === 'on';
}

export function shouldRenderMuiBanner() {
  return getTreatment('disc_mui_promo_banner') === 'on';
}

export function shouldTurnOnCaptionsByDefault() {
  return getTreatment('lx_translated_subtitles_on_by_default') === 'on';
}

export function shouldRenderTeacherReferralLocd() {
  return getTreatment('gr_tr_locd') === 'on';
}

export function shouldConsolidateEmailSettings() {
  return getTreatment('i18n_cons_emlset_web') === 'on';
}

export function shouldRenderChromaCourseLinkOnGlobalNav() {
  return getTreatment('lx_cc_gn') === 'on';
}
